import { ThemeSwitch } from '@/components/theme-switch'
import { LanguageSwitch } from '@/components/language-switch'
import { useTranslation } from '@/hooks/use-translation'

interface Props {
  children: React.ReactNode
}

export default function AuthLayout({ children }: Props) {
  const { t } = useTranslation()
  return (
    <div className='container grid h-svh flex-col items-center justify-center bg-background lg:max-w-none lg:px-0'>
      <div className='mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[480px] lg:p-8'>
        <div className='mb-4 flex flex-col items-center justify-center gap-3'>
          <img src="/images/logo-orange.png" alt="Menu Points" className="h-12 w-auto md:h-16" />
          <div className='flex items-center justify-center gap-2'>
            <h1 className='text-xl font-medium'>{t('Menu Points Admin')}</h1>
            <LanguageSwitch />
            <ThemeSwitch />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
